import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonRow } from '@ionic/angular/standalone';
import { SlipComponentHeaderComponent } from '../slip-component-header/slip-component-header.component';
import { QuestionsInfo } from '../student-slip-modal.store';

@Component({
  selector: 'app-student-slip-questions',
  templateUrl: './student-slip-questions.component.html',
  styleUrls: ['./student-slip-questions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SlipComponentHeaderComponent, IonRow, IonButton]
})
export class StudentSlipQuestionsComponent {
  @Input() model: QuestionsInfo;
  @Output() view = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();

  get buttonInfo(): { legend: string; op: EventEmitter<void> } {
    switch (this.model.status) {
      case 'pending':
        return { legend: 'View and Respond', op: this.edit };
      case 'done':
        return { legend: this.model.redacted ? 'View Questions' : 'View Responses', op: this.view };
      case 'restricted':
        return { legend: 'Preview', op: this.view };
      case 'void':
        return { legend: 'View Questions', op: this.view };
      case 'expired':
        return { legend: 'View Questions', op: this.view };
    }
  }
}
